import { gql } from '@apollo/client';

export type BookedQuote = {
  uuid: string;
  quotePriceDetails: {
    customerTotalAmount: number;
  };
  suppliers: {
    uuid: string;
    name: string;
  };
  event_requests: {
    id: string;
    categories_tier2: {
      parent: string;
    };
    events: {
      id: string;
      date: string;
      location_line_1: string;
      location_line_2: string;
      location_city: string;
    };
    conversations: {
      uuid: string;
      supplier_id: string;
    }[];
  };
};

export type BookedQuotesResponse = {
  quotes: BookedQuote[];
};

const BOOKED_QUOTE_FIELDS = gql`
  fragment BookedQuoteFields on quotes {
    uuid
    quotePriceDetails {
      customerTotalAmount
    }
    suppliers {
      uuid
      name
    }
    event_requests {
      id
      categories_tier2 {
        parent
      }
      events {
        id
        date
        location_line_1
        location_line_2
        location_city
      }
      conversations {
        uuid
        supplier_id
      }
    }
  }
`;

export const ACTIVE_BOOKED_QUOTES = gql`
  ${BOOKED_QUOTE_FIELDS}
  query customerBookings($userId: String!, $currentDate: DateTime!) {
    quotes(
      where: {
        event_requests: {
          events: { user_id: { equals: $userId }, date: { gte: $currentDate } }
        }
        state: { equals: booked }
      }
      orderBy: [{ eventDate: asc }, { created: desc }]
    ) {
      ...BookedQuoteFields
    }
  }
`;

export const PAST_BOOKED_QUOTES = gql`
  ${BOOKED_QUOTE_FIELDS}
  query customerBookings($userId: String!, $currentDate: DateTime!) {
    quotes(
      where: {
        event_requests: {
          events: { user_id: { equals: $userId }, date: { lt: $currentDate } }
        }
        state: { equals: booked }
      }
      orderBy: [{ eventDate: desc }, { created: desc }]
    ) {
      ...BookedQuoteFields
    }
  }
`;

export const CANCELLED_BOOKED_QUOTES = gql`
  ${BOOKED_QUOTE_FIELDS}
  query customerBookings($userId: String!) {
    quotes(
      where: {
        event_requests: { events: { user_id: { equals: $userId } } }
        state: { equals: cancelled }
      }
      orderBy: [{ eventDate: desc }, { created: desc }]
    ) {
      ...BookedQuoteFields
    }
  }
`;
